import { WithStyles } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import * as React from 'react';
import i18n from '../resources/i18n';

import { IPortalGroupTraining } from '../actions/portal';

const styles = (theme: Theme) =>
	createStyles({
		card: {
			height: '100%',
			width: 200,
		},
		content: {
			padding: theme.spacing(1),
		},
		groupTrainingTitle: {
			color: theme.palette.primary.main,
			fontSize: '108%',
			marginBottom: theme.spacing(1),
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			wordBreak: 'break-all',
		},
		link: {
			color: 'blue',
			cursor: 'pointer',
			display: 'inline-block',
			wordBreak: 'break-word',
		},
		media: {
			height: 0,
			paddingTop: '56.25%',
		},
	});

interface IPortalNoticeTableRowProps {
	groupTraining: IPortalGroupTraining;
	handleShowDetailDialog: (e: React.MouseEvent<HTMLElement>) => void;
}
interface IProps
	extends React.Props<{}>,
		WithStyles<typeof styles>,
		IPortalNoticeTableRowProps {}

/**
 * お知らせ集合研修表形式
 * @param props
 */
const PortalNoticeTableRow: React.FC<IProps> = props => {
	const { classes, groupTraining, handleShowDetailDialog } = props;
	let fromToDate = groupTraining.fromToDate;
	if (fromToDate && fromToDate.indexOf('～') !== -1) {
		fromToDate = fromToDate.replace(
			'～',
			i18n.t('～', {
				ns: 'force',
			})
		);
	}
	return (
		<TableRow>
			<TableCell style={{ width: '35%' }}>
				<span
					className={classes.link}
					onClick={handleShowDetailDialog}
					data-careerid={groupTraining.careerID}
				>
					{groupTraining.title}
				</span>
			</TableCell>
			<TableCell style={{ width: '25%' }}>
				{groupTraining.className}
			</TableCell>
			<TableCell>{fromToDate}</TableCell>
		</TableRow>
	);
};
export default withStyles(styles)(PortalNoticeTableRow) as React.ComponentClass<
	IPortalNoticeTableRowProps
>;



// WEBPACK FOOTER //
// ./src/components/PortalNoticeGTTableRow.tsx